import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pur-gas',
  templateUrl: './pur-gas.component.html',
  styleUrls: ['./pur-gas.component.css']
})
export class PurGasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
